import BaseService from "src/packages/BaseService";

export default class ProjectService extends BaseService {
	static get className () {
		return "project";
	}

	static checkSubscription (userId, projectHash) {
		return BaseService.getService().get("/subscription/verifyUser/" + projectHash).then((response) => {
			if (response.data) {
				return response;
			} else {
				throw new Error(response.data);
			}
		});
	}
};
